import { GatsbyImage, getSrc } from 'gatsby-plugin-image';
import get from 'lodash/get';
import isString from 'lodash/isString';
import React from 'react';

import { Carousel } from '../Carousel';
import { ImageCaption } from '../ImageCaption';
import * as styles from './ImageRow.module.scss';

type Props = {
  images: readonly Pick<
    Queries.ContentfulAsset,
    'title' | 'gatsbyImageData' | 'description'
  >[];
};

export const ImageRow: React.FC<Props> = ({ images }): JSX.Element => {
  return (
    <Carousel
      slides={images.map((image) => {
        const hasCaption = get(image, 'metadata.tags', []).some(
          (tag) =>
            tag.contentful_id === 'hasCaption' ||
            tag.contentful_id === 'needsCredit',
        );

        return (
          <figure
            className={styles.image}
            key={getSrc(image.gatsbyImageData)}
            style={{
              aspectRatio: `${image.gatsbyImageData.width} / ${image.gatsbyImageData.height}`,
            }}
          >
            <GatsbyImage
              image={image.gatsbyImageData}
              alt={image.description || image.title}
            />
            {hasCaption && isString(image.description) ? (
              <ImageCaption caption={image.description} />
            ) : null}
          </figure>
        );
      })}
    />
  );
};

export default ImageRow;
